import http from '@/http'
import createCrudModule from 'vuex-crud'

export default createCrudModule({
  client: http,
  resource: 'profile/organizations/office',
  urlRoot: 'profile/organizations/office',

  actions: {
    update({ commit }, { id, data, config } = {}) {
      commit('updateStart')
      return http
        .post(`profile/organizations/office/${id}`, data, config)
        .then(res => {
          commit('updateSuccess', res)
          return res
        })
        .catch(err => {
          commit('updateError', err)
          return Promise.reject(err)
        })
    }
  }
})
